import type { QueryClient } from '@tanstack/react-query';

import type { Generation, GenerationPage } from './resources.js';

export const activeGenerationStatuses = [
  'queued',
  'submitting',
  'submitted',
  'processing',
] as const;

const activeGenerationStatusSet = new Set<string>(activeGenerationStatuses);

export function hasActiveGeneration(page: GenerationPage | undefined): boolean {
  return (
    page?.items.some((generation) => activeGenerationStatusSet.has(generation.status)) ?? false
  );
}

export function generationLifecycleRefetchInterval(
  page: GenerationPage | undefined,
  visibleAndOnline: boolean,
): 3_000 | false {
  return visibleAndOnline && hasActiveGeneration(page) ? 3_000 : false;
}

export function mergeAcceptedGeneration(
  page: GenerationPage | undefined,
  accepted: Generation,
): GenerationPage {
  return {
    items: [accepted, ...(page?.items ?? []).filter((generation) => generation.id !== accepted.id)],
    next_cursor: page?.next_cursor ?? null,
  };
}

export function shouldReconcileGenerationReadModels({
  active,
  previouslyActive,
}: {
  active: boolean;
  previouslyActive: boolean;
}): boolean {
  return active || previouslyActive;
}

const generationReadModelQueryPrefixes = [
  ['catalog'],
  ['library-tracks'],
  ['playlist'],
  ['playlist-items'],
  ['generation'],
  ['delivery'],
  ['projects'],
  ['project'],
  ['track'],
  ['activity'],
] as const;

export async function invalidateGenerationReadModels(queryClient: QueryClient): Promise<void> {
  await Promise.all(
    generationReadModelQueryPrefixes.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  );
}
